/* eslint-disable @typescript-eslint/no-unused-vars */
import { createTool } from '@mastra/client-js'
import { z } from 'zod'
import store from 'src/store'
import { actions as appActions } from 'src/store/modules/app'

import {
  IUseRouterObjectPageSearchQuery,
  ObjectPageTabs,
} from 'src/hooks/router/useRouterObjectPage'

export const sendSMSTool = createTool({
  id: 'send-sms',
  description:
    'Send an SMS message to a contact. Use this when user wants to send a text message or when suggesting to send a message.',
  inputSchema: z.object({
    childrenSchemeIdentifier: z
      .string()
      .optional()
      .describe(
        'Unique identifier scheme of the children object to navigate to'
      ),
    childrenUniqId: z
      .string()
      .optional()
      .describe('Unique identifier of the children object to navigate to'),
    parentUniqId: z
      .string()
      .describe('Unique identifier of the parent object to navigate to'),
    parentSchemeIdentifier: z
      .string()
      .describe('Unique identifier scheme of the parent object to navigate to'),
    phoneNumber: z.string().describe('Recipient phone number'),
    messageText: z.string().describe('Text content of the SMS message'),
    skipConfirmation: z
      .boolean()
      .describe(
        'If true, send the message immediately without asking for user confirmation'
      ),
  }),
  outputSchema: z.object({
    success: z.boolean(),
    message: z.string(),
  }),

  execute: async ({ context }) => {
    const {
      parentSchemeIdentifier,
      parentUniqId,
      childrenSchemeIdentifier,
      childrenUniqId,
      phoneNumber,
      messageText,
      // skipConfirmation,
    } = context

    const skipConfirmation = false
    const querySearch: IUseRouterObjectPageSearchQuery = {
      objectPage: {
        selectedTab: ObjectPageTabs.MESSAGES,
        [ObjectPageTabs.MESSAGES]: {
          initialMessage: messageText,
        },
        selectedChildren:
          childrenSchemeIdentifier && childrenUniqId
            ? {
                schemeName: childrenSchemeIdentifier,
                objectUniqId: childrenUniqId,
              }
            : undefined,
      },
    }
    store.dispatch(
      appActions.navigate({
        path: `/storage/${parentSchemeIdentifier}/${parentUniqId}`,
        search: querySearch,
      })
    )

    return {
      success: true,
      message: `${
        skipConfirmation ? 'Sending' : 'Preparing to send'
      } SMS to ${phoneNumber}`,
    }
  },
})
